export default __webpack_public_path__ + "static/media/attach_money.0ba7fd4d.svg";